module.exports = __webpack_public_path__ + "img/9788974427443.2c2249a5.jpg";